import { uniqueId } from '@disy/lib/unique-id';

import { ajax } from 'cadenza/api-client/api';
import type { NavigatorTreeNodeDto, NavigatorTreeNodeId } from 'cadenza/repository/model/navigator-tree-node-dto';
import { isParentNode } from 'cadenza/repository/model/navigator-tree-node-dto';

/**
 * Fetches the navigation tree.
 *
 * @see net/disy/cadenza/repository/web/rest/NavigatorTreeEndpointController.java
 */
export async function getNavigatorTree(defaultRepositoryPublicationStage: string = 'DEVELOPMENT') {
  const urlParams = new URLSearchParams({ defaultRepositoryPublicationStage });
  const tree = await ajax<NavigatorTreeNodeDto>(`/navigator-tree/?${urlParams}`, {
    dataType: 'json',
  });
  return processTree(tree);
}

/**
 * Sanitizes the tree from the server to match the TS types:
 *
 * * Generates a tree-wide unique identifier as `id` property.
 * * Sets the `parent` property on child nodes. It cannot be included in the JSON,
 *   because JSON cannot handle cyclic references.
 * * Ensures the `itemType` property to be set. It is redundant for nodes with an `itemId`,
 *   and hence not included in the JSON for them.
 */
function processTree(node: NavigatorTreeNodeDto) {
  node.id = uniqueId() as NavigatorTreeNodeId;
  if (isParentNode(node)) {
    node.children = node.children.map((child) => {
      child.parent = node;
      return processTree(child);
    });
  }
  if (node.itemId) {
    node.itemType = node.itemId.itemType as NavigatorTreeNodeDto['itemType'];
  }
  return node;
}
